export default {
	data() {
		return {
			formNumLength: 9,     // how many digits is the form num>
			participants: [],
			participantFields: [
				{label: "Name",key:'name'},
				{label: "Company Name",key:'company_name'},
				{label: "Email",key:'email'},
				{label: "Phone",key:'phone'},
				{label: "Signing Status",key:'signingStatus'}
			]
		}
	},
	computed: {
		mutatedParticipants() {
			let vm = this

			let consolidated = []
			this.participants.forEach(part => {
				let matchIndex = consolidated.findIndex(added => {
					if ("user_id" in added && "user_id" in part && part.user_id == added.user_id && added.user_id > 0)
						return true

					else if ("email" in added && "email" in part && part.email == added.email && part.email)
						return true
					
					else if ("phone" in added && "phone" in part && part.phone == added.phone && part.phone)
						return true
				})
				
				if (matchIndex >= 0 && "is_invite" in consolidated[matchIndex] && consolidated[matchIndex].is_invite == 1 && "is_invite" in part && part.is_invite == 0) {
					//current added record is an invite, replace it with the signature record
					consolidated.splice(matchIndex,1,part)
				}
				else if (matchIndex == -1)
					consolidated.push(part)
			})

			return consolidated.map(part => {

				part.showSignatureButton = false

				part.signingStatus = "<i class='fa fa-signature'></i> Now"
				if ("completed_at" in part && part.completed_at) {
					part.showSignatureButton = true
					part.signingStatus = "<i class='fa fa-signature'></i> " + vm.formatDateTimeToLocal(part.completed_at)
				}
				else if (part.is_invite == 1 && !('acknowledgement_slug' in this.$route.params && part.slug == this.$route.params.acknowledgement_slug) &&
					!('user_id' in part && part.user_id && part.user_id == this.$store.userDetails.id)) {
					part.signingStatus = "<i class='fa fa-send'></i> Invite"
				}

				part.signature = null
				if ('signature_json' in part && part.signature_json) {
					try {
						part.signature = JSON.parse(part.signature_json)
					} catch (e) {
					}
				}

				return part
			})
		},
	},
	methods: {
		getThumbSrc(image, type="images") {
			if (!this.$store.sessionToken)
				return ""

			if ("thumb_filename" in image)
				return window.apiRoot+"resources/" + type + "/"+this.$store.sessionToken+"/"+image.thumb_filename

			let filename = image.filename

			let segs = filename.split(".")
			segs[segs.length-2] = segs[segs.length-2]+"-thumb"

			filename = segs.join(".")

			return window.apiRoot+"resources/" + type + "/"+this.$store.sessionToken+"/"+filename
		},
		getMainSrc(image, type = 'images') {
			return (this.$store.sessionToken) ? window.apiRoot+"resources/" + type + "/"+this.$store.sessionToken+"/"+image.filename : ""
		},
		showConditionalRemarks(field) {

			let fieldValue = field.value
			if (field.type == 'boolean') {
				if (fieldValue === 1)
					fieldValue = true
				else if (fieldValue === '' || fieldValue === null)
					fieldValue = null
				else
					fieldValue = false
			}

			let cleanedConditionalRemarksValue = field.conditionalRemarksValue
			if (typeof field.conditionalRemarksValue == 'object')
				cleanedConditionalRemarksValue = field.conditionalRemarksValue.filter(value => value !== null && typeof value !== 'undefined')

			let conditionalRemarksValueMatchesValue = false
			if ((fieldValue === false || fieldValue === 0) && (cleanedConditionalRemarksValue === false || cleanedConditionalRemarksValue === 0))
				conditionalRemarksValueMatchesValue = true
			else if (fieldValue === field.conditionalRemarksValue)
				conditionalRemarksValueMatchesValue = true

			return 'conditionalRemarksActive' in field && field.conditionalRemarksActive && (conditionalRemarksValueMatchesValue || (typeof cleanedConditionalRemarksValue == 'object' && cleanedConditionalRemarksValue.indexOf(fieldValue) >= 0))
		},
		showConditionalImageField(field) {
			let fieldValue = field.value
			if (field.type == 'boolean') {
				if (fieldValue === 1)
					fieldValue = true
				else if (fieldValue === "" || fieldValue === null)
					fieldValue = null
				else
					fieldValue = false
			}

			let cleanedConditionalImageValue = field.conditionalImageValue
			if (typeof field.conditionalImageValue == 'object')
				cleanedConditionalImageValue = field.conditionalImageValue.filter(value => value !== null && typeof value !== 'undefined')

			let conditionalImageValueMatchesValue = false
			if ((fieldValue === false || fieldValue === 0) && (field.conditionalImageValue === false || field.conditionalImageValue === 0))
				conditionalImageValueMatchesValue = true
			else if ((fieldValue === field.conditionalImageValue))
				conditionalImageValueMatchesValue = true

			return 'conditionalImageActive' in field && field.conditionalImageActive && (conditionalImageValueMatchesValue || (typeof cleanedConditionalImageValue == 'object' && cleanedConditionalImageValue.indexOf(fieldValue) >= 0))

		},
		mutateAcknowledgeLog(json) {
			let vm = this

			let acks = []

			try {
				acks = JSON.parse(json)
			}
			catch (e) {
				return []
			}

			return acks.map(ack => {
				ack.userName = ack.first_name+" "+ack.last_name
				ack.completedAt = vm.formatDateTimeToLocal(ack.completed_at)

				return ack
			})
		},
		fetchTemplateCategories(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			return new Promise((resolve,reject) => {

				vm.getJSON("FormTemplateCategory/get").then(response => {
					if (response.success)
						vm.$store.companyFormTemplateCategories = response.data

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})
			})
		},
		fetchTemplates(args) {
			let vm = this

			let localArgs = {
				cat_id: false,
				include: false,
				skipSetData: false,
				spinner: false,
				worksheetFormsOnly: false
			}

			//set arguments into variables
			Object.keys(args).forEach(key => {
				localArgs[key] = args[key]
			})

			if (localArgs.spinner)
				this.spinner(true)

			return new Promise((resolve,reject) => {

				let params = {}

				if (localArgs.cat_id) {
					params.filters = [
						["category_id",localArgs.cat_id]
					]
				}

				if (localArgs.worksheetFormsOnly) {
					if (!("filters" in params))
						params.filters = []

					params.filters.push(["is_worksheet_form",1])
				}

				if (localArgs.include)
					params.include = localArgs.include

				vm.getJSON("FormTemplate/get",params,true).then(response => {
					if (localArgs.spinner)
						vm.spinner(false)

					if (!localArgs.skipSetData)
						vm.templates = response.data

					resolve(response)
				})

			})
		},
		fetchChildTemplates(template_id,spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			return new Promise((resolve,reject) => {

				let params = {}

				if (template_id) {
					params.filters = [
						["form_template_id",template_id]
					]
				}

				vm.getJSON("FormChildTemplate/get",params).then(response => {
					if (spinner)
						vm.spinner(false)
					
					resolve(response)
				})

			})
		},
		fetchTemplate(slug) {
			let vm = this

			return new Promise((resolve,reject) => {

				vm.getJSON("FormTemplate/find/"+slug,{include:["EquipmentType","JobPersonnelRole"]}).then(response => {
					resolve(response)
				})

			})
		},
		fetchCompanyForm(idOrSlug,securityToken) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {
					include: [
						{model: "FormChildTemplate",include: ["FormTemplate"]},
						{model: "Job"},
						{model: "Service"},
						{model: "User",fields: ["id","slug",'first_name','last_name']},
						"Equipment",
						"CompanyFormAcknowledgement"
					]
				}

				if (securityToken)
					params.token = securityToken

				vm.getJSON("CompanyForm/find/"+idOrSlug,params,false,{noUnauthRedirect: true}).then(response => {
					resolve(response)
				})

			})
		},
		hazardOptions(selectedList) {
			return this.optionify(this.hazards.filter(item => {
				if (selectedList && selectedList.find(selectedItem => selectedItem == item.description))
					return false
				
				return true	
			}),"description",true)
		},
		controlOptions(selectedList) {
			return this.optionify(this.controls.filter(item => {
				if (selectedList && selectedList.find(selectedItem => selectedItem == item.description))
					return false
				
				return true	
			}),"description",true)
		}
	}
}